
import moment from "moment";
import { ActionContext } from "vuex";
import { CommunicationStateInterface } from "./types";
import Notification from "@/types/app/notifications";
import store from "@/store";
import Schedule from "@/types/app/schedules";
import NotificationInterface from "@/types/app/notifications";
moment.locale("en-US");
export default {
  
  setModalNewNotificationState(
    store: ActionContext<CommunicationStateInterface, any>,
    show: boolean
  ) {
    store.commit("setModalNewNotificationState", show);
  },
  setModalNotificationState(
    store: ActionContext<CommunicationStateInterface, any>,
    show: boolean
  ) {
    store.commit("setModalNotificationState", show);
  },
  setNotificationState(
    store: ActionContext<CommunicationStateInterface, any>,
    notification: NotificationInterface
  ) {
    store.commit("setNotificationState", notification);
  },
  setNotificationsState(
    store: ActionContext<CommunicationStateInterface, any>,
    notifications: NotificationInterface[]
  ) {
    store.commit("setNotificationsState", notifications);
  },
  setNotificationSent(
    store: ActionContext<CommunicationStateInterface, any>,
    show: boolean
  ) {
    store.commit("setNotificationSent", show);
  },  
  setModalNotificationDelete(
    store: ActionContext<CommunicationStateInterface, any>,
    show: boolean
  ) {
    store.commit("setModalNotificationDelete", show);
  },  
  setScheduleState(
    store: ActionContext<CommunicationStateInterface, any>,
    schedule: Schedule
  ) {
    store.commit("setScheduleState", schedule);
  },
  setModalScheduleState(
    store: ActionContext<CommunicationStateInterface, any>,
    show: boolean
  ) {
    store.commit("setModalScheduleState", show);
  },
  setScheduleFeedbackModalState(
    store: ActionContext<CommunicationStateInterface, any>,
    show: boolean
  ) {
    store.commit("setScheduleFeedbackModalState", show);
  },
  setModalNewEmailNotificationState(
    store: ActionContext<CommunicationStateInterface, any>,
    show: boolean
  ) {
    store.commit("setModalNewEmailNotificationState", show);
  },
  setModalEmailNotificationState(
    store: ActionContext<CommunicationStateInterface, any>,
    show: boolean
  ) {
    store.commit("setModalEmailNotificationState", show);
  },
  setEmailNotificationState(
    store: ActionContext<CommunicationStateInterface, any>,
    notification: NotificationInterface
  ) {
    store.commit("setEmailNotificationState", notification);
  },
  setEmailNotificationsState(
    store: ActionContext<CommunicationStateInterface, any>,
    notifications: NotificationInterface[]
  ) {
    store.commit("setEmailNotificationsState", notifications);
  },
  setEmailNotificationSent(
    store: ActionContext<CommunicationStateInterface, any>,
    show: boolean
  ) {
    store.commit("setEmailNotificationSent", show);
  },
  setModalEmailNotificationModalDelete(
    store: ActionContext<CommunicationStateInterface, any>,
    show: boolean
  ) {
    store.commit("setModalEmailNotificationDelete", show);
  },
  clearAllData(
    store: ActionContext<CommunicationStateInterface, any>
  ) {
    store.commit("clearAllData");
  },
};
